export class chartDate {

  dob: string;
  month: string = null;
  day: string = null;
  year: string = null;
}
